module.exports = __webpack_public_path__ + "static/week_week4_spot2-e372a197126d66f49009b3376f8cca5e.jpg";